module.exports = __webpack_public_path__ + "static/media/profileold.15cee44a.jpg";